<template>
  <article class="c-webmention-entry h-entry p-comment">
    <header class="c-webmention-entry__header">
      <ul class="c-webmention-entry__meta">
        <li
          class="c-webmention-entry__meta-item c-webmention-entry__meta-item--author"
        >
          <ul class="c-webmention-entry__author h-card">
            <li class="c-webmention-entry__author-avatar">
              <a
                :href="author.url"
                class="c-webmention-entry__author-photo-link u-url"
              >
                <cloudinary-image
                  class="c-webmention-entry__author-photo u-photo"
                  :source-url="author.photo.url"
                  :source-width="author.photo.width"
                  :source-height="author.photo.height"
                  :widths="[64, 96, 128]"
                  :lazyload="true"
                  :fallback="true"
                  sizes="64px"
                  width="64"
                  height="64"
                  :alt="`${author.name}'s avatar`"
                />
              </a>
            </li>

            <li class="c-webmention-author__author-name">
              <viewsource-link :href="author.url" class="p-name">
                {{ author.name }}
              </viewsource-link>
            </li>
          </ul>
        </li>

        <li
          class="c-webmention-entry__meta-item c-webmention-entry__meta-item--date-published"
        >
          <time
            :datetime="published.iso8601"
            class="c-webmention-entry__date-published dt-published"
            >{{ published.pretty }}</time
          >
        </li>

        <li
          class="c-webmention-entry__meta-item c-webmention-entry__meta-item--permalink"
        >
          <viewsource-link
            :href="url"
            class="c-webmention-entry__permalink u-url"
            :title="`View ${author.name}'s Webmention`"
            >Permalink</viewsource-link
          >
        </li>
      </ul>
    </header>

    <div
      class="c-webmention-entry__body s-webmention-entry-body e-content"
      data-qa="webmention-entry-body"
      v-html="content.html"
    ></div>
  </article>
</template>

<script>
import CloudinaryImage from '@saulhardman/vue-cloudinary-image';

import ViewsourceLink from '~/components/ViewsourceLink.vue';

export default {
  components: {
    CloudinaryImage,
    ViewsourceLink,
  },

  props: {
    author: {
      type: Object,

      required: true,
    },

    content: {
      type: Object,

      required: true,
    },

    published: {
      type: Object,

      required: true,
    },

    url: {
      type: String,

      required: true,
    },
  },
};
</script>

<style lang="postcss">
@import '@/assets/css/scopes/scopes.webmention-entry-body.css';

:root {
  --webmention-entry-avatar-size: 64px;
}

.c-webmention-entry {
  margin: 0 0 0 calc(var(--webmention-entry-avatar-size) + var(--spacing-5));
}

.c-webmention-entry__meta {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-flow: row wrap;

  @media (--beta) {
    flex-flow: row nowrap;
  }
}

.c-webmention-entry__meta-item {
  @nest & + .c-webmention-entry__meta-item {
    margin-top: var(--spacing-2);

    @media (--beta) {
      margin-top: 0;
    }
  }
}

.c-webmention-entry__author {
  display: flex;
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
}

.c-webmention-entry__author-avatar {
  position: absolute;
  left: calc((var(--webmention-entry-avatar-size) + var(--spacing-5)) * -1);
}

.c-webmention-entry__author-photo-link {
  position: relative;
  display: block;
  width: var(--webmention-entry-avatar-size);
  height: var(--webmention-entry-avatar-size);
}

.c-webmention-entry__author-photo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.c-webmention-entry__meta-item--date-published,
.c-webmention-entry__meta-item--permalink {
  flex: 0 0 100%;
  font-size: var(--font-size-0);

  @media (--beta) {
    flex: 0 0 auto;
  }
}

.c-webmention-entry__meta-item--date-published {
  @media (--beta) {
    padding: 0 var(--spacing-3);

    &::before {
      content: '\2013';
      padding-right: var(--spacing-3);
    }
  }
}

.c-webmention-entry__meta-item--permalink {
  @media (--beta) {
    margin-left: auto;
  }

  &::before {
    content: '\1F517';
    padding: 0 var(--spacing-2) 0 0;
  }
}

.c-webmention-entry__body {
  padding: var(--spacing-3) 0 0;
}
</style>
